/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import PersonalMessage from "@/src/components/Form/AbstractLitigationCase/PersonalMessage";
import React from "react";
import FormSubmitProps from "@/src/types/FormSubmitProps";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";

type ContractLawContractRecommendationDescriptionProps = {
  submitProps: FormSubmitProps;
  applicationStatus: number;
  product: AbstractCase;
};

export const ContractLawContractRecommendationDescription = ({ submitProps, applicationStatus, product }: ContractLawContractRecommendationDescriptionProps) => {
  return (
    <PersonalMessage
      submitProps={submitProps}
      validatorMessage={"Bitte schildern Sie uns hier kurz Ihre Anliegen."}
      applicationStatus={applicationStatus}
      product={product}
    />
  );
};
